import { computed, ComputedRef } from 'vue'

import { useLastIncident } from '@desktop/views/Relation/composables'
import { useIncidentsTeamPossession } from '@desktop/views/Relation/Sports/composables'
import { injectIncidentsRequirePointingPositionConfig } from '@desktop/views/Relation/Sports/provide-inject'

import PossessionAwayAttack from './possession-away-attack.svg'
import PossessionAwayDangerousAttack from './possession-away-dangerous-attack.svg'
import PossessionAwayDefaultSvg from './possession-away-default.svg'
import PossessionAwayInPossession from './possession-away-in-possession.svg'
import PossessionHomeAttack from './possession-home-attack.svg'
import PossessionHomeDangerousAttack from './possession-home-dangerous-attack.svg'
import PossessionHomeDefaultSvg from './possession-home-default.svg'
import PossessionHomeInPossession from './possession-home-in-possession.svg'

export function usePossessionSvg(): {
  possessionHomeSvg: ComputedRef<string>
  possessionAwaySvg: ComputedRef<string>
} {
  // inject
  const { getPossessionSvg: getPossessionSvgFromConfig } =
    injectIncidentsRequirePointingPositionConfig()

  // composables
  const { lastNonDeletedIncidentWithPosition } = useLastIncident()
  const { isLastIncidentDefaultPossession, isLastIncidentTeamInPossession } =
    useIncidentsTeamPossession()

  // methods
  function getPossessionSvg(
    defaultSvg: string,
    inPossessionSvg: string,
    attackSvg: string,
    dangerousAttackSvg: string,
    isAway = false,
  ): string {
    if (
      isLastIncidentDefaultPossession() ||
      !lastNonDeletedIncidentWithPosition.value ||
      !isLastIncidentTeamInPossession()
    ) {
      return getPossessionSvgFromConfig({
        defaultSvg,
        inPossessionSvg,
        attackSvg,
        dangerousAttackSvg,
        isAway,
      })
    }

    return getPossessionSvgFromConfig(
      {
        defaultSvg,
        inPossessionSvg,
        attackSvg,
        dangerousAttackSvg,
        isAway,
      },
      lastNonDeletedIncidentWithPosition.value.incident_id,
      lastNonDeletedIncidentWithPosition.value.x_pos ?? undefined,
    )
  }

  // computed
  const possessionHomeSvg = computed(() =>
    getPossessionSvg(
      PossessionHomeDefaultSvg,
      PossessionHomeInPossession,
      PossessionHomeAttack,
      PossessionHomeDangerousAttack,
      false,
    ),
  )

  const possessionAwaySvg = computed(() =>
    getPossessionSvg(
      PossessionAwayDefaultSvg,
      PossessionAwayInPossession,
      PossessionAwayAttack,
      PossessionAwayDangerousAttack,
      true,
    ),
  )

  return { possessionHomeSvg, possessionAwaySvg }
}
